import { useRecord } from "./useRecord";

export function useOrganizationUserInvitation(organizationUserInvitationId?: string | null) {
  return useRecord("organization_user_invitation", organizationUserInvitationId, {
    name: "useOrganizationUserInvitation",
  });
}
